import React from 'react';
import { useTranslation } from '../../../hooks';

const PrivacyPolicy = () => {
  const { t, language } = useTranslation();

  const privacySections = [
    {
      title: t.privacy.sections.dataCollection.title,
      content: t.privacy.sections.dataCollection.content
    },
    {
      title: t.privacy.sections.dataUsage.title,
      content: t.privacy.sections.dataUsage.content
    },
    {
      title: t.privacy.sections.dataSharing.title,
      content: t.privacy.sections.dataSharing.content
    },
    {
      title: t.privacy.sections.dataSecurity.title,
      content: t.privacy.sections.dataSecurity.content
    },
    {
      title: t.privacy.sections.thirdParty.title,
      content: t.privacy.sections.thirdParty.content
    },
    {
      title: t.privacy.sections.userRights.title,
      content: t.privacy.sections.userRights.content
    },
    {
      title: t.privacy.sections.childrenPrivacy.title,
      content: t.privacy.sections.childrenPrivacy.content
    },
    {
      title: t.privacy.sections.policyChanges.title,
      content: t.privacy.sections.policyChanges.content
    }
  ];

  return (
    <div className="privacy-policy" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <div className="privacy-policy-container">
        {/* Header */}
        <div className="privacy-header">
          <div className="privacy-header-content">
            <div className="privacy-header-text">
              <h1>{t.privacy.title}</h1>
              <p className="privacy-last-updated">{t.privacy.lastUpdated}</p>
            </div>
          </div>
        </div>

        {/* Introduction */}
        <div className="privacy-intro">
          <p>{t.privacy.introduction}</p>
        </div>

        {/* Privacy Sections */}
        <div className="privacy-sections">
          {privacySections.map((section, index) => (
            <div key={index} className="privacy-section">
              <div className="privacy-section-header">
                <h2>{section.title}</h2>
              </div>
              <div className="privacy-section-content">
                <p>{section.content}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default PrivacyPolicy;
